// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"be240aee","575":"1661c231","744":"d72f93bd","801":"3fad4401","981":"2e0a0abe"}[chunkId] + ".chunk.js";
};